import $http from '../../../../../axios-instance';

/**
 * Guardar la configuración de etiquetas asociada al producto.
 *
 * @param Object { commit, dispatch }
 * @param Object payload -> { productId, versionId, languageId, companyId }
 * @return void
 */
export async function storeLabelConfigurationByProduct({ commit, dispatch }, payload) {
    commit("dashboard/load", true, { root: true });  
    try {

        const { data: response } = await $http.post(`/products/sga2/config-labels`, payload);

        this.$vue.$alertSuccess(response.message);

        const { 
            prod_product_id: productId, 
            sga_version_id: versionId, 
            sga_language_id: languageId, 
            slq_company_id: companyId 
        } = payload
        dispatch('getLabelConfigurationByProduct', { productId, versionId, languageId, companyId }); 
        
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Obtener la configuración de etiquetas asociada al producto.
 *
 * @param Object { state, commit }
 * @param Object params -> { productId, versionId, languageId, companyId }
 * @return void
 */
export async function getLabelConfigurationByProduct({ state, commit }, params) {
    commit("dashboard/load", true, { root: true });
    commit('resetProductLabelConfigs');        
    try {

        const { data: response } = await $http.get(`/products/sga2/config-labels`, { params });
        if(response && typeof response === 'object' && 'data' in response && response.data && typeof response.data === 'object') {
            
            const configs = response.data;

            commit('setProductLabelConfigs', {
                ...configs,
                measures: (configs.measures && typeof configs.measures === 'string') ? 
                    JSON.parse(configs.measures) : 
                    state.productLabelConfigs.measures
            });  
        }      
        
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Eliminar la configuración de etiquetas asociada al producto.
 *
 * @param Object { commit, dispatch }
 * @param Object params -> { productId, versionId, languageId, companyId }
 * @return void
 */
export async function deleteLabelConfigurationByProduct({ commit, dispatch }, params) {
    commit("dashboard/load", true, { root: true });
    commit('resetProductLabelConfigs');        
    try {

        const { data: response } = await $http.delete(`/products/sga2/config-labels`, { params });

        this.$vue.$alertSuccess(response.message);

        dispatch('getLabelConfigurationByProduct', params); 
        
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}